import React, { Component } from "react";
import { Link } from "react-router";
import FontAwesome from "./FontAwesome";
import firebase from "firebase";
import { history } from "../store";

import "./LogIn.css";

class LogIn extends Component {
  constructor() {
    super();

    this.state = {
      username: "",
      password: "",
      loginError: ""
    };

    this.login = this.login.bind(this);
    this.usernameChanged = this.usernameChanged.bind(this);
    this.passwordChanged = this.passwordChanged.bind(this);
  }

  login(event) {
    event.preventDefault();

    if (this.state.username && this.state.password) {
      this.setState({ loginError: "" });
      const self = this;
      return firebase
        .auth()
        .signInWithEmailAndPassword(this.state.username, this.state.password)
        .catch(function(error) {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(`Error ${errorCode}:`, errorMessage);
          self.setState({ loginError: errorMessage });
        })
        .then(user => {
          if (user) {
            this.setState({ username: "", password: "" });
            // console.log('identifying user...',user.uid,user.displayName,user.email);
            // log FullStory session user
            window.FS.identify(user.uid, {
              displayName: user.displayName,
              email: user.email
            });
            history.push("/");
          }
          // 	console.log({id:user.uid, options: {
          //   displayName: user.displayName,
          //   email: user.email,
          // }});
        });
    }
  }

  usernameChanged(event) {
    this.setState({ username: event.target.value });
  }

  passwordChanged(event) {
    this.setState({ password: event.target.value });
  }

  render() {
    return (
      <section id="login-view" className="card">
        <div className="card-body">
          <h2 className="card-title">Please log in</h2>

          <form id="login-form" onSubmit={this.login}>
            <div className="form-group">
              <label htmlFor="username" className="required">
                Email
              </label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <FontAwesome type="solid" name="envelope" />
                  </span>
                </div>
                <input
                  id="username"
                  className="form-control"
                  type="email"
                  required
                  value={this.state.username}
                  onChange={this.usernameChanged}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="password" className="required">
                Password
              </label>
              {/* <Link to="/reset">forgot password</Link> */}
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <FontAwesome type="solid" name="key" />
                  </span>
                </div>
                <input
                  id="password"
                  className="form-control"
                  type="password"
                  required
                  value={this.state.password}
                  onChange={this.passwordChanged}
                />
              </div>
            </div>
            <div className="login-actions">
              <div className="footer-toolbar">
                <div className="toolbar">
                  <Link className="card-link" to="/signup">
                    Create an account
                  </Link>
                  {/*<Link className="card-link" to="/reset">Forgot password</Link>*/}
                  <button type="submit" className="btn btn-primary">
                    Log In
                  </button>
                </div>
              </div>
            </div>
            {this.state.loginError ? (
              <div className="alert alert-danger" role="alert">
                {this.state.loginError}
              </div>
            ) : (
              ""
            )}
          </form>
        </div>
      </section>
    );
  }
}

export default LogIn;



// WEBPACK FOOTER //
// ./src/components/LogIn.js